/**
 * Copyright 2025 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { Link } from "react-router-dom";
import { FlexContainer, SVGIcon, theme } from "@nordcloud/gnui";
import { UpdateStatusForResource } from "~/generated/graphql";
import { getUpdateStatusDetails } from "../utils";

type StatusLinkProps = {
  status: UpdateStatusForResource["updateStatus"];
  count?: UpdateStatusForResource["pendingUpdateCount"];
  to?: string;
};

export function StatusLink({ status, count, to }: StatusLinkProps) {
  const { label, icon } = getUpdateStatusDetails(status);
  const statusLabel = count ? `${label} (${count})` : label;

  return (
    <FlexContainer gap={theme.spacing.spacing02} alignItems="center">
      <SVGIcon name={icon} />
      {to ? <Link to={to}>{statusLabel}</Link> : statusLabel}
    </FlexContainer>
  );
}
